// extracted by mini-css-extract-plugin
export default {"date":"T1zHxGyQ","header":"ksLh9cPw","mobile":"zprU7hRf"};